import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

// modules
// import { HelperFormModule  } from '../form/form.module';

// components
import { CoreHelpersSsoProvidersComponent } from './sso-providers/sso-providers.component';

@NgModule({
    imports: [
        CommonModule,
        // HelperFormModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        CoreHelpersSsoProvidersComponent
    ],
    exports: [
        CoreHelpersSsoProvidersComponent
    ],

})
export class HelperSsoModule { }
